import {
  AudioRecordingModelData,
  AudioRecordingUploadStatus,
} from "@/store/audio-recordings/types";
import { BaseAudioRecordingAppEventOperation } from "./BaseAudioRecordingAppEventOperation";
import { AudioRecordingAppEventOperationKind } from "@/store/sync/operations/types";

export class MarkCompletedUploadingAudioRecordingOperation extends BaseAudioRecordingAppEventOperation {
  get operationKind(): AudioRecordingAppEventOperationKind {
    return "MARK_COMPLETED_UPLOADING_AUDIO_RECORDING";
  }

  protected getModelDataUpdates(
    existingData: AudioRecordingModelData
  ): Partial<AudioRecordingModelData> {
    // SKIPPED is terminal and should not transition to COMPLETED.
    if (existingData.upload_status === AudioRecordingUploadStatus.SKIPPED) {
      return {};
    }

    return {
      upload_status: AudioRecordingUploadStatus.COMPLETED,
    };
  }
}
